module.exports = require("@swa-ui/vacations/src/VacationsRecentSearch/VacationsRecentSearchItem/VacationsRecentSearchItem.module.scss");